import { ReactNode } from 'react';
import styles from './styles.module.css';
import classNames from 'classnames';

type Props = {
  title: string;
  children?: ReactNode;
  isChange?: boolean;
};

function Box({ title, children, isChange = false }: Props) {
  return (
    <div
      className={classNames(
        styles.box,
        isChange ? styles.isChange : styles.isNotChange
      )}
    >
      <div className={styles.boxTitle}>{title}</div>
      <hr className={styles.border} />
      {children}
    </div>
  );
}

export default Box;
